import { CodeSnippetSchema } from '@nucleus/sites/src/types/CodeSnippet';
import { z } from 'zod';

/** @deprecated Just use the strings instead. */
export const ContentType = {
  Stack: 'stack',
  Section: 'section',
  Hub: 'hub',
  Navigation: 'navigation',
} as const;

export type ContentType = z.infer<typeof ContentTypeSchema>;

export const ContentTypeSchema = z.enum(['stack', 'section', 'hub', 'navigation']);

export type StackContent = z.infer<typeof StackContentSchema>;
export type SectionContent = z.infer<typeof SectionContentSchema>;
export type HubContent = z.infer<typeof HubContentSchema>;
export type NavigationContent = z.infer<typeof NavigationContentSchema>;

export type ContentData = StackContent | SectionContent | HubContent | NavigationContent;

const BaseContentDataSchema = z.object({
  type: ContentTypeSchema,
  id: z.string(),
  codeSnippets: z.array(CodeSnippetSchema).optional(),
});

export const StackContentSchema = BaseContentDataSchema.extend({
  type: z.literal('stack'),
  payload: z.object({
    stackId: z.string(),
  }),
});

export const isStackContent = (content: ContentData): content is StackContent =>
  StackContentSchema.safeParse(content).success;

export const SectionContentSchema = BaseContentDataSchema.extend({
  type: z.literal('section'),
  payload: z.object({
    sectionId: z.string(),
  }),
});

export const isSectionContent = (content: ContentData): content is SectionContent =>
  SectionContentSchema.safeParse(content).success;

export const HubContentSchema = BaseContentDataSchema.extend({
  type: z.literal('hub'),
  payload: z.object({
    hubId: z.string(),
  }),
});

export const isHubContent = (content: ContentData): content is HubContent =>
  HubContentSchema.safeParse(content).success;

export const NavigationContentSchema = BaseContentDataSchema.extend({
  type: z.literal('navigation'),
  payload: z.object({
    navigationId: z.string(),
  }),
});

export const isNavigationContent = (content: ContentData): content is NavigationContent =>
  NavigationContentSchema.safeParse(content).success;

export const ContentDataSchema = z.discriminatedUnion('type', [
  StackContentSchema,
  SectionContentSchema,
  HubContentSchema,
  NavigationContentSchema,
]);

export const ContentTypeToIdKeyMap = {
  stack: 'stackId',
  section: 'sectionId',
  hub: 'hubId',
  navigation: 'navigationId',
} as const;
